var map = {
	"./DailyRosterLogo.png": 1270,
	"./Switch Shift Icon_2-01.svg": 1842,
	"./apparatus.png": 510,
	"./approve.svg": 820,
	"./bid.svg": 821,
	"./calendar_mouse.jpg": 511,
	"./callout.svg": 822,
	"./cancel.svg": 823,
	"./clockin.svg": 824,
	"./clockout.svg": 825,
	"./completedShift.png": 1271,
	"./create.svg": 826,
	"./cross_station.png": 512,
	"./day.png": 513,
	"./delete.svg": 827,
	"./deny.svg": 828,
	"./dutyBadge.png": 1272,
	"./duty_sm.png": 514,
	"./edit.svg": 1843,
	"./editShift.png": 515,
	"./emptyShift.png": 1273,
	"./emptyUserSpecificShift.png": 1274,
	"./event.svg": 829,
	"./exchange.svg": 415,
	"./filledShift.png": 1275,
	"./full.svg": 830,
	"./header_background_main.jpg": 1276,
	"./lateShift.png": 1277,
	"./month.png": 516,
	"./netDutyLogo.png": 331,
	"./netDutyLogo_police.png": 1278,
	"./netDuty_logo.png": 1279,
	"./offer.svg": 831,
	"./offer2.svg": 832,
	"./onDutyPolice.png": 517,
	"./onduty.svg": 833,
	"./overtime.png": 518,
	"./partial.svg": 834,
	"./partialShift.png": 519,
	"./payperiod.png": 520,
	"./pto.svg": 835,
	"./reports.svg": 836,
	"./scheduled_duty.svg": 837,
	"./shift.svg": 838,
	"./shiftboard.png": 521,
	"./signup.svg": 268,
	"./signup_event.svg": 839,
	"./softWarning.png": 1280,
	"./station.png": 522,
	"./sub.svg": 840,
	"./time_change.svg": 841,
	"./timeclock_record.svg": 842,
	"./timeoff.svg": 843,
	"./userSpecificShift.png": 523,
	"./warning.png": 524,
	"./week.png": 525
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1844;



//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*$
// module id = 1844
// module chunks = 0